import { Component, OnInit } from '@angular/core';
import { DisplayModes } from '../../../models/enums';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { BusinessUnitService } from '../../business-unit/business-unit.service';
import { ItemService } from '../../item/item.service';
import { HCPClass } from '../../models/hcpclass.model';
import { HCPService } from '../hcp.service';
import { classSaveErrorMessage, parseClassDate, toClassDateString } from '../../../services/class-period.helper';



@Component({
  selector: 'crm-save-hcp-brand-class',
  templateUrl: './save-hcp-brand-class.component.html',
  styleUrls: ['./save-hcp-brand-class.component.css']
})
export class SaveHcpBrandClassComponent implements OnInit {
  businessUnits: any[] = [];
  classes: HCPClass[] = [];
  filteredClasses: HCPClass[] = [];
  hcpBrandsClass: any = {} as any;
  displayMode: DisplayModes = DisplayModes.Success;
  maxDate = new Date();

  public changesSavedCallback: () => void;
  public changesFailedCallback: () => void;
  public changesCancelledCallback: () => void;

  constructor(private itemService: ItemService,
    private readonly hcpService: HCPService, private businessUnitService: BusinessUnitService,
    private readonly translateService: AppTranslationService,
    private readonly alertService: AlertService) { }



  ngOnInit() {
    this.getHCPClasses();
    this.getBusinessUnitsRootLevel();
  }

  getHCPClasses() {
    this.displayMode = DisplayModes.Loading;
    this.hcpService.GetAllHCPClasses("").subscribe(response => {
      const results = response;
      this.classes = results as HCPClass[];
      this.classes = this.classes.filter(x => x.isHcpClass)
      this.onChangeBu();
      if (this.hcpBrandsClass.classId && !this.hcpBrandsClass.class)
        this.hcpBrandsClass.class = this.filteredClasses.find(x => x.id === this.hcpBrandsClass.classId);
      this.displayMode = DisplayModes.Success;
    }, () => {
      this.displayMode = DisplayModes.Error;
    });
  }

  getBusinessUnitsRootLevel() {
    this.businessUnitService.getBusinessUnitsRootLevel().subscribe(response => {
      this.businessUnits = response as any[];
      if (this.hcpBrandsClass.businessUnitId && !this.hcpBrandsClass.businessUnit) {
        this.hcpBrandsClass.businessUnit = this.businessUnits.find(x => x.id === this.hcpBrandsClass.businessUnitId);
        this.onChangeBu();
        if (this.hcpBrandsClass.classId && !this.hcpBrandsClass.class)
          this.hcpBrandsClass.class = this.filteredClasses.find(x => x.id === this.hcpBrandsClass.classId);
      }
    }, error => { });
  }

  createNew(hcpId: number) {
    this.hcpBrandsClass = { hcpId: hcpId, startDate: new Date() };
    this.filteredClasses = [];
  }

  edit(hcpBrandsClass: any) {
    this.hcpBrandsClass = Object.assign({}, hcpBrandsClass);
    this.hcpBrandsClass.startDate = parseClassDate(hcpBrandsClass.startDate);
    this.hcpBrandsClass.endDate = parseClassDate(hcpBrandsClass.endDate);
    this.hcpBrandsClass.businessUnit = this.businessUnits.find(x => { return x.id === this.hcpBrandsClass.businessUnitId; });
    this.onChangeBu();
    this.hcpBrandsClass.class = this.filteredClasses.find(x => { return x.id === this.hcpBrandsClass.classId });
  }

  save(form) {
    if (!form.invalid) {
      if (!this.hcpBrandsClass.businessUnit || !this.hcpBrandsClass.class || !this.hcpBrandsClass.startDate) {
        this.alertService.showMessage("", this.translateService.getTranslation("app.RequiredField"), MessageSeverity.Error);
        return;
      }
      this.displayMode = DisplayModes.Saving;
      this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));

      const payload = {
        id: this.hcpBrandsClass.id || 0,
        hcpId: this.hcpBrandsClass.hcpId,
        businessUnitId: this.hcpBrandsClass.businessUnit.id,
        classId: this.hcpBrandsClass.class.id,
        startDate: toClassDateString(this.hcpBrandsClass.startDate),
        endDate: toClassDateString(this.hcpBrandsClass.endDate)
      };

      this.hcpService.saveCPBrandHCPClass(payload).subscribe(response => {
        this.displayMode = DisplayModes.Success;
        this.alertService.showMessage("", this.translateService.getTranslation("hcos.messages.classSavedSuccessfully"), MessageSeverity.Success);
        this.alertService.stopLoadingMessage();
        if (this.changesSavedCallback)
          this.changesSavedCallback();
      }, error => {
        console.log(error);
        this.displayMode = DisplayModes.Error;
        this.alertService.stopLoadingMessage();
        this.alertService.showStickyMessage("Save Error", classSaveErrorMessage(error), MessageSeverity.Error);
      });
    }
  }

  close() {
    if (this.changesCancelledCallback)
      this.changesCancelledCallback();
  }

  onChangeBu() {
    // Classes without a business unit are valid in every one.
    this.filteredClasses = this.hcpBrandsClass.businessUnit
      ? this.classes.filter(x => !x.businessUnitId || x.businessUnitId === this.hcpBrandsClass.businessUnit.id)
      : [];
  }

}
